import { useMemo } from 'react';
import { useUser } from '@/queries/useUser';

/**
 * Hook to check completion status for each onboarding step
 * Returns boolean flags indicating whether each step has been completed
 */
export function useOnboardingStepStatus() {
    const { user } = useUser();

    const isProfileImageUploaded = useMemo(() => {
        return user?.['onboarding-dashboard']?.profile_image_uploaded ?? false;
    }, [user]);

    const isSocialLinksAdded = useMemo(() => {
        return user?.['onboarding-dashboard']?.social_links_added ?? false;
    }, [user]);

    const isFirstProductAdded = useMemo(() => {
        return user?.['onboarding-dashboard']?.first_product_added ?? false;
    }, [user]);

    const isDirectDepositAdded = useMemo(() => {
        if (!user?.integrations) return false;
        return !!(user.integrations['stan-payment'] || user.integrations['stripe-connect'] || user.integrations.paypal);
    }, [user]);

    return {
        isProfileImageUploaded,
        isSocialLinksAdded,
        isFirstProductAdded,
        isDirectDepositAdded,
    };
}
